import React from 'react';

export default function LoadingOverlay() {
    return (
        <div className='loading-overlay' />
    )
}